import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => {
  return {
    emptyWrap: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    emptyTitle: {
      margin: '16px 0',
    },
    emptyIcon: {
      fontSize: 60,
    },
    wrapper: {
      margin: '160px 0',
    },
  };
});
